import { runtime } from '../../classes/runtime/Runtime';
class Xa {
    xaProxy(classifier) {
        return new Proxy(this, {
            get(xa, command) {
                return data => xa.run_xa(classifier, command, data);
            },
        });
    }
    async run_xa(classifier, command, data) {
        const response = await runtime.axios.post(`${runtime.isServerRuntime ? `https://${runtime.stagePrefix}.schlaukopf.de` : ''}/api/xa/${classifier}/${command}`, {
            classifier,
            command,
            data,
            pageHref: window !== 'undefined' && decodeURI(window.location.href),
        });
        const reply = response.data ? response.data.payload : undefined;
        if (runtime.isServerRuntime && runtime.isDevelopmentStage || window.location.host.startsWith('dev.')) {
            // console.log(`xa reply for ${classifier}_${command}`, reply);
        }
        return reply;
    }
    auth = this.xaProxy('auth');
    user = this.xaProxy('user');
    personalTopic = this.xaProxy('personalTopic');
    topic = this.xaProxy('topic');
    question = this.xaProxy('question');
    answer = this.xaProxy('answer');
    audio = this.xaProxy('audio');
    video = this.xaProxy('video');
    admin = this.xaProxy('admin');
    edit = this.xaProxy('edit');
    race = this.xaProxy('race');
    entity = this.xaProxy('entity');
    prisma = this.xaProxy('prisma');
}
export const xa = new Xa();
